import { render, staticRenderFns } from "./CommandCenter.vue?vue&type=template&id=a4b052b6&scoped=true&"
import script from "./CommandCenter.vue?vue&type=script&lang=js&"
export * from "./CommandCenter.vue?vue&type=script&lang=js&"
import style0 from "./CommandCenter.vue?vue&type=style&index=0&id=a4b052b6&prod&lang=scss&scoped=true&"
import style1 from "./CommandCenter.vue?vue&type=style&index=1&id=a4b052b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b052b6",
  null
  
)

export default component.exports